import React from 'react';
import AvailabilityCodeIcon from '../../general/AvailabilityCodeIcon';
import { linkToNewDutyTransaction } from '../../../utils/dutyTransactions';
import { formatTimeOnlyShort } from '../../../utils/time';
import { Dropdown } from '../../ui-kit';
import { IconCalendarXmark, IconTrash } from '../../ui-kit/icons';
import moment from 'moment';

class ScheduleIntervalContextMenu extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  handleClose = () => this.props.setShow(false);

  // hide context menu when clicking anywhere outside the dropdown
  componentDidMount = () => {
    document.addEventListener('click', this.handleClose, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleClose, false);
  };

  applyAvailabilityCode = code => {
    this.props.updateIntervalById(this.props.interval.id, {
      availability_code_id: code && code.id
    });
    this.handleClose();
  };

  splitInterval = () => {
    this.props.splitInterval(this.props.interval.membership_id, 'membership', this.props.time);
    this.handleClose();
  };

  render = () => {
    if (!this.props.show) return null;
    if (!this.props.interval) return null;

    const { start_time, end_time, membership_id } = this.props.interval;
    const params = { start_time: moment(start_time).format(), end_time: moment(end_time).format() };
    const absenceRequestPath = linkToNewDutyTransaction('absence_requests', membership_id, params);
    // const dutyExchangePath = linkToNewDutyTransaction('duty_exchanges', membership_id, params);

    // store ref to node so we can detect when user clicks outside dropdown
    return (
      <Dropdown.ContextMenu x={this.props.coordX} y={this.props.coordY} show={true}>
        {this.props.time && (
          <Dropdown.Item onClick={this.splitInterval}>
            {I18n.t('duty_planner.context_menu.split')} {formatTimeOnlyShort(this.props.time)}
          </Dropdown.Item>
        )}
        <Dropdown.Item onClick={this.props.openCommentsDialog}>{I18n.t('edit_comments')}</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.SubMenu title={I18n.t('activerecord.models.schedule/availability_code.other')}>
          <Dropdown.Item onClick={() => this.applyAvailabilityCode(null)} key={'none'}>
            <i>{I18n.t('none')}</i>
          </Dropdown.Item>
          <Dropdown.Divider />
          {this.props.availabilityCodes.map(code => (
            <Dropdown.Item onClick={() => this.applyAvailabilityCode(code)} key={code.id}>
              <AvailabilityCodeIcon code={code} /> {code.name}
            </Dropdown.Item>
          ))}
        </Dropdown.SubMenu>
        <Dropdown.Divider />
        {/* <Dropdown.Item onClick={this.handleClose} href={dutyExchangePath} target="blank"> */}
        {/*   <IconExchange /> {I18n.t('schedules.standby_duty.actions.exchange')} */}
        {/* </Dropdown.Item> */}
        <Dropdown.Item onClick={this.handleClose} href={absenceRequestPath} target="blank">
          <IconCalendarXmark /> {I18n.t('schedules.standby_duty.actions.absence_request')}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => this.props.removeInterval(this.props.interval)}>
          <IconTrash /> {I18n.t('delete')}
        </Dropdown.Item>
        <Dropdown.Item onClick={this.handleClose}>{I18n.t('cancel')}</Dropdown.Item>
      </Dropdown.ContextMenu>
    );
  };
}

export default ScheduleIntervalContextMenu;
